"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CongridProjects = exports.mapStateToProps = void 0;
var React = require("react");
var memoize = require("fast-memoize");
var react_redux_1 = require("react-redux");
var classNames = require("classnames");
var recompose_1 = require("recompose");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var viewport_1 = require("reducers/viewport");
var components_1 = require("components");
var sok_ui_1 = require("@caddigital/sok-ui");
var List_1 = require("@caddigital/sok-ui/lib/components/List");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var translate_1 = require("utils/translate");
var Types = require("types");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        selectedLanguage: selectedLanguage,
        token: state.auth.current.token,
        isMobile: (0, viewport_1.isMobile)(state.viewport)
    };
};
exports.mapStateToProps = mapStateToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var enhanceHeader = (0, recompose_1.compose)((0, recompose_1.shouldUpdate)(function (nextProps, props) {
    return nextProps.width !== props.width ||
        (0, List_1.shallowDiffers)(nextProps.style, props.style);
}));
var Header = enhanceHeader(function (props) {
    return (React.createElement("div", { className: props.className + ' header row', style: props.style },
        React.createElement("div", { className: "row__column narrow icon" }),
        getHeaderColumn('name', 'name'),
        props.displayRemove && getHeaderColumn('remove', 'remove')));
});
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, {}), (0, recompose_1.withState)('items', 'setItems', []), (0, recompose_1.withState)('width', 'setWidth', 0), (0, recompose_1.lifecycle)({
    componentDidUpdate: function (prevProps) {
        var items = this.props.projects;
        if ((prevProps.projects.length === 0 && this.props.projects.length) ||
            this.props.projects !== prevProps.projects ||
            (this.props.status !== 'FETCHED' && prevProps.status === 'FETCHED')) {
            this.props.setItems(items);
        }
    },
    shouldComponentUpdate: function (nextProps) {
        if (this.props.selected !== nextProps.selected ||
            this.props.items !== nextProps.items ||
            this.props.projects !== nextProps.projects ||
            this.props.status !== nextProps.status) {
            return true;
        }
        return false;
    }
}));
function getHeaderColumn(name, identifier) {
    var dataKey = '__' + identifier;
    return (React.createElement("div", { key: identifier, "data-key": dataKey, "data-length": name.length, className: classNames('row__column dynamic congrid-projects-list-row-column extends', dataKey) },
        React.createElement("div", null, (0, translation_1.getLocalization)("congrid-modal/list/header/".concat(name)))));
}
// Helper function memoizes props to avoid unnecessary re-renders of Row component.
var createRowData = memoize(function (projects, selectedLanguage, unlink, selected, toggleSelection) { return ({
    projects: projects,
    selectedLanguage: selectedLanguage,
    unlink: unlink,
    selected: selected,
    toggleSelection: toggleSelection
}); });
var ListRow = React.memo(function (_a) {
    var index = _a.index, data = _a.data, className = _a.className, style = _a.style;
    var projects = data.projects, toggleSelection = data.toggleSelection, selected = data.selected;
    var props = data;
    var row = projects[index];
    return (React.createElement("div", { className: classNames('row'), style: style },
        React.createElement("div", { className: 'row__column narrow' }, selected && (React.createElement(components_1.TableRowIcon, { circle: true, icon: 'fa-check', onClick: function (e) {
                e.stopPropagation();
                toggleSelection(row.congridId);
            }, className: selected.indexOf(row.congridId) > -1 ? 'selected' : null }))),
        React.createElement("div", null,
            React.createElement("div", { className: classNames("row__column dynamic __name", 'expand'), "data-key": "__name" }, row.name)),
        !!props.unlink && (React.createElement("div", { className: 'row__column remove __remove' },
            React.createElement(components_1.TableRowIcon, { circle: true, icon: 'fa-times', onClick: function (e) {
                    e.stopPropagation();
                    props.unlink(row.congridId);
                }, className: 'red' })))));
});
exports.CongridProjects = enhance(function (props) {
    var itemData = createRowData(props.items, props.selectedLanguage, props.unlink, props.selected, props.toggleSelection);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'congrid-projects-view-list-container' },
            React.createElement("div", { className: 'sok-list-content congrid-projects-view-list ' +
                    props.status.toLowerCase() },
                props.status === 'FAILED' && (React.createElement(GenericErrorMessage_1.default, { key: 'error', title: (0, translation_1.getLocalization)('generic/error') },
                    React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function (e) { return props.fetchAgain(); } }))),
                props.status === 'FETCHING' && (React.createElement("div", { key: 'loading', className: 'loading' },
                    React.createElement(sok_ui_1.LoadingSpinner, null))),
                props.status === 'FETCHED' && (React.createElement(React.Fragment, null, props.items.length > 0 && (React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                    var width = _a.width, height = _a.height;
                    return (width > 0 && (React.createElement(sok_ui_1.List, { itemData: itemData, itemCount: props.items.length, overscanCount: 8, width: width, height: height, itemHeight: 50, itemWidth: width, header: React.createElement(Header, { width: width, displayRemove: !!props.unlink }) }, ListRow)));
                }))))))));
});
